import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../translation/translation_container';
import { LightboxView } from './view_sections/lightbox_view';
import { LightboxViewHeadline } from './view_sections/lightbox_view_headline';
import { LightboxViewContent } from './view_sections/lightbox_view_content';
import { LightboxViewAction } from './view_sections/view_actions/lightbox_view_action';
import { LightboxFilterCheckbox } from './filters/lightbox_filter_checkbox';
import { FilterSections } from '../../../../constants/filter/filter_sections';
import { Filters } from '../../../../constants/filter/filters';
import { FilterSectionLabelTranslationKeys } from '../../../../constants/filter/filter_section_label_translation_keys';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';

function LightboxQualitySegment(props) {
    const sectionHeadlineTranslationKey = FilterSectionLabelTranslationKeys[FilterSections.QUALITY_SEGMENT_VIEW];
    const premiumTranslationKey = FilterLabelTranslationKeys[Filters.QUALITY_SEGMENT_PREMIUM];
    const valueTranslationKey = FilterLabelTranslationKeys[Filters.QUALITY_SEGMENT_VALUE];
    const budgetTranslationKey = FilterLabelTranslationKeys[Filters.QUALITY_SEGMENT_BUDGET];
    return (
        <LightboxView
            viewName={FilterSections.QUALITY_SEGMENT_VIEW}
            opened={props.opened}
        >
            <TranslationContainer translationKey={sectionHeadlineTranslationKey} targetProperty="headline">
                <LightboxViewHeadline headline="will-be-replaced" />
            </TranslationContainer>

            <LightboxViewContent>
                <LightboxFilterCheckbox
                    name={Filters.QUALITY_SEGMENT_PREMIUM}
                    checked={props.qualitySegmentPremiumValue}
                    labelTranslationKey={premiumTranslationKey}
                    onChange={props.onChange}
                    disabled={!props.qualitySegmentPremiumEnabled}
                />

                <LightboxFilterCheckbox
                    name={Filters.QUALITY_SEGMENT_VALUE}
                    checked={props.qualitySegmentValueValue}
                    labelTranslationKey={valueTranslationKey}
                    onChange={props.onChange}
                    disabled={!props.qualitySegmentValueEnabled}
                />

                <LightboxFilterCheckbox
                    name={Filters.QUALITY_SEGMENT_BUDGET}
                    checked={props.qualitySegmentBudgetValue}
                    labelTranslationKey={budgetTranslationKey}
                    onChange={props.onChange}
                    disabled={!props.qualitySegmentBudgetEnabled}
                />
            </LightboxViewContent>

            <LightboxViewAction
                onCloseClick={props.resetSection}
                onSaveClick={props.saveSection}
            />
        </LightboxView>
    );
}

LightboxQualitySegment.propTypes = {
    qualitySegmentPremiumValue: PropTypes.bool.isRequired,
    qualitySegmentValueValue: PropTypes.bool.isRequired,
    qualitySegmentBudgetValue: PropTypes.bool.isRequired,
    qualitySegmentPremiumEnabled: PropTypes.bool.isRequired,
    qualitySegmentValueEnabled: PropTypes.bool.isRequired,
    qualitySegmentBudgetEnabled: PropTypes.bool.isRequired,

    onChange: PropTypes.func.isRequired,
    resetSection: PropTypes.func.isRequired,
    saveSection: PropTypes.func.isRequired,
    opened: PropTypes.bool.isRequired,
};

export { LightboxQualitySegment };
